// extracted by mini-css-extract-plugin
module.exports = {"splashPagePerson":"SplashPagePerson_splashPagePerson__HnHqH","hover":"SplashPagePerson_hover__yMO2o"};